<template>
  <UserGet
    v-if="(!data.isSendUser && !data.isToUser) || data.isToUser"
    :data="data"
  />
  <UserGive
    v-if="data.isSendUser"
    :data="data"
  />

</template>

<script>
import { reactive, toRefs } from "vue";
import { useRoute } from "vue-router";
import UserGive from "./components/UserGive";
import UserGet from "./components/UserGet";
import { sendInfo } from "@/api/mine";
import { useAuth } from "@/hooks/useAuth";

export default {
  name: "giveDetail",
  components: {
    UserGive,
    UserGet,
  },

  setup() {
    const route = useRoute();
    const state = reactive({
      data: {},
    });
    const { send_code } = route.query;

    // 授权钩子
    useAuth(
      {
        auth_type: 2,
      },
      init
    );

    async function init() {
      const { data } = await sendInfo({ send_code });
      state.data = data;
    }

    return {
      ...toRefs(state),
    };
  },
};
</script>

<style lang="scss" scoped>
</style>